function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  fill: "#19191A"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0591 20.5051H17.3426V19.7372C17.3426 18.6007 17.6996 18.0171 18.9638 17.157C20.2859 16.256 21 15.1809 21 13.6655V13.6553C21 11.5666 19.3595 10 17.0434 10C14.5537 10 13.1737 11.6894 13.0097 13.7372L13 13.8601H14.2545L14.2642 13.7577C14.3993 12.2423 15.4608 11.2184 16.9952 11.2184C18.5392 11.2184 19.6393 12.2628 19.6393 13.727V13.7372C19.6393 14.8328 19.1665 15.5495 17.9602 16.3993C16.6092 17.3311 16.0591 18.1911 16.0591 19.5427V20.5051ZM16.7153 25C17.2268 25 17.6224 24.5802 17.6224 24.0478C17.6224 23.5051 17.2268 23.0853 16.7153 23.0853C16.2135 23.0853 15.8179 23.5051 15.8179 24.0478C15.8179 24.5802 16.2135 25 16.7153 25Z",
  fill: "white"
});
const SvgInstruction = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstruction, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instruction.81ec33fd.svg";
export { ForwardRef as ReactComponent };